module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAB+SURBVDhPY6AlkAHiYiCWBvOIABZAXI6EzwHxMiiNLG4PxFhBBRAfB+IDULoDiEEARMPEQHQ7EGMFIANAkiB6PxAj27odiGFyBA1wAGKQrejYA4iJMgAfIMkAEP8/DozVEGwGYFOI0xWjBkAkiAltnAagA2wGwjBRBhABGBgAVhY9sgUwXAAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Grey/Paste16.png
// module id = 673
// module chunks = 0